var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-sector-query-view"},[_c('StockSectorQuery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }